import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, withModifiers as _withModifiers, createBlock as _createBlock, createVNode as _createVNode, createStaticVNode as _createStaticVNode } from "vue";
const _hoisted_1 = { class: "shadow sm:rounded-t-md sm:overflow-hidden" };
const _hoisted_2 = { class: "bg-white py-6 px-4 space-y-6 sm:p-6" };
const _hoisted_3 = /*#__PURE__*/ _createElementVNode("div", null, [
    /*#__PURE__*/ _createElementVNode("h3", { class: "text-lg leading-6 font-medium text-gray-900" }, "\n            Candidate Details\n          ")
], -1);
const _hoisted_4 = { class: "flex items-start flex-col my-4" };
const _hoisted_5 = /*#__PURE__*/ _createElementVNode("p", null, "Does the candidate have any direct reports? *", -1);
const _hoisted_6 = {
    key: 0,
    class: "text-red-500"
};
const _hoisted_7 = { class: "h-5 mt-4 flex items-center" };
const _hoisted_8 = ["disabled", "checked"];
const _hoisted_9 = /*#__PURE__*/ _createElementVNode("div", { class: "ml-3 text-sm" }, [
    /*#__PURE__*/ _createElementVNode("label", {
        for: "directReports",
        class: "font-medium text-gray-700 cursor-pointer"
    }, "Yes")
], -1);
const _hoisted_10 = { class: "h-5 mt-4 flex items-center" };
const _hoisted_11 = ["disabled", "checked"];
const _hoisted_12 = /*#__PURE__*/ _createElementVNode("div", { class: "ml-3 text-sm" }, [
    /*#__PURE__*/ _createElementVNode("label", {
        for: "directReports",
        class: "font-medium text-gray-700 cursor-pointer"
    }, "No")
], -1);
const _hoisted_13 = {
    key: 0,
    class: "mt-6"
};
const _hoisted_14 = /*#__PURE__*/ _createElementVNode("label", {
    for: "directReportsInfo",
    class: "block text-sm font-medium text-gray-700"
}, "Please specify *", -1);
const _hoisted_15 = ["value", "disabled"];
const _hoisted_16 = {
    key: 0,
    class: "text-red-500"
};
const _hoisted_17 = { class: "flex items-start flex-col my-4" };
const _hoisted_18 = /*#__PURE__*/ _createElementVNode("p", null, "Are you offering this position to an internal candidate? *", -1);
const _hoisted_19 = {
    key: 0,
    class: "text-red-500"
};
const _hoisted_20 = { class: "h-5 mt-4 flex items-center" };
const _hoisted_21 = ["disabled", "checked"];
const _hoisted_22 = /*#__PURE__*/ _createElementVNode("div", { class: "ml-3 text-sm" }, [
    /*#__PURE__*/ _createElementVNode("label", {
        for: "internal_candidate",
        class: "font-medium text-gray-700 cursor-pointer"
    }, "Yes")
], -1);
const _hoisted_23 = { class: "h-5 mt-4 flex items-center" };
const _hoisted_24 = ["disabled", "checked"];
const _hoisted_25 = /*#__PURE__*/ _createElementVNode("div", { class: "ml-3 text-sm" }, [
    /*#__PURE__*/ _createElementVNode("label", {
        for: "internal_candidate",
        class: "font-medium text-gray-700 cursor-pointer"
    }, "No")
], -1);
const _hoisted_26 = { key: 1 };
const _hoisted_27 = { class: "flex items-start flex-col my-4" };
const _hoisted_28 = /*#__PURE__*/ _createElementVNode("p", null, "Is this employee transferring from another EQUANS company? *", -1);
const _hoisted_29 = {
    key: 0,
    class: "text-red-500"
};
const _hoisted_30 = { class: "h-5 mt-4 flex items-center" };
const _hoisted_31 = ["disabled", "checked"];
const _hoisted_32 = /*#__PURE__*/ _createElementVNode("div", { class: "ml-3 text-sm" }, [
    /*#__PURE__*/ _createElementVNode("label", {
        for: "transferring",
        class: "font-medium text-gray-700 cursor-pointer"
    }, "Yes")
], -1);
const _hoisted_33 = { class: "h-5 mt-4 flex items-center" };
const _hoisted_34 = ["disabled", "checked"];
const _hoisted_35 = /*#__PURE__*/ _createElementVNode("div", { class: "ml-3 text-sm" }, [
    /*#__PURE__*/ _createElementVNode("label", {
        for: "tempTermProcess",
        class: "font-medium text-gray-700 cursor-pointer"
    }, "No")
], -1);
const _hoisted_36 = { class: "flex items-start flex-col my-4" };
const _hoisted_37 = /*#__PURE__*/ _createElementVNode("p", null, "Is the starter as a result of the Temp to Perm Process(i.e. were they already working here as an Agency\n                Worker?) *", -1);
const _hoisted_38 = {
    key: 0,
    class: "text-red-500"
};
const _hoisted_39 = { class: "h-5 mt-4 flex items-center" };
const _hoisted_40 = ["disabled", "checked"];
const _hoisted_41 = /*#__PURE__*/ _createElementVNode("div", { class: "ml-3 text-sm" }, [
    /*#__PURE__*/ _createElementVNode("label", {
        for: "tempTermProcess",
        class: "font-medium text-gray-700 cursor-pointer"
    }, "Yes")
], -1);
const _hoisted_42 = { class: "h-5 mt-4 flex items-center" };
const _hoisted_43 = ["disabled", "checked"];
const _hoisted_44 = /*#__PURE__*/ _createElementVNode("div", { class: "ml-3 text-sm" }, [
    /*#__PURE__*/ _createElementVNode("label", {
        for: "tempTermProcess",
        class: "font-medium text-gray-700 cursor-pointer"
    }, "No")
], -1);
const _hoisted_45 = { class: "mt-6" };
const _hoisted_46 = /*#__PURE__*/ _createElementVNode("label", {
    for: "d59Number",
    class: "block text-sm font-medium text-gray-700"
}, "If known / applicable please specify\n                the employees GID/D59 number", -1);
const _hoisted_47 = ["value", "disabled"];
const _hoisted_48 = /*#__PURE__*/ _createElementVNode("p", { class: "text-sm text-red-700" }, [
    /*#__PURE__*/ _createElementVNode("b", null, "Please note:"),
    /*#__PURE__*/ _createTextVNode(" the employees name must be entered as shown on\n              their right to work documentation. Any offers submitted where the name\n              differs will be rejected.\n            ")
], -1);
const _hoisted_49 = { class: "grid grid-cols-3 gap-6" };
const _hoisted_50 = { class: "col-span-6" };
const _hoisted_51 = /*#__PURE__*/ _createElementVNode("label", {
    for: "title",
    class: "block text-sm font-medium text-gray-70"
}, "Title *", -1);
const _hoisted_52 = ["value"];
const _hoisted_53 = /*#__PURE__*/ _createElementVNode("option", null, "Mr", -1);
const _hoisted_54 = /*#__PURE__*/ _createElementVNode("option", null, "Mrs", -1);
const _hoisted_55 = /*#__PURE__*/ _createElementVNode("option", null, "Miss", -1);
const _hoisted_56 = /*#__PURE__*/ _createElementVNode("option", null, "Ms", -1);
const _hoisted_57 = /*#__PURE__*/ _createElementVNode("option", null, "Dr", -1);
const _hoisted_58 = /*#__PURE__*/ _createElementVNode("option", null, "Mx", -1);
const _hoisted_59 = {
    key: 0,
    class: "text-red-500"
};
const _hoisted_60 = { class: "mt-6" };
const _hoisted_61 = /*#__PURE__*/ _createElementVNode("label", {
    for: "firstName",
    class: "block text-sm font-medium text-gray-700"
}, "First Name: *", -1);
const _hoisted_62 = ["value", "disabled"];
const _hoisted_63 = {
    key: 0,
    class: "text-red-500"
};
const _hoisted_64 = { class: "mt-6" };
const _hoisted_65 = /*#__PURE__*/ _createElementVNode("label", {
    for: "knownAs",
    class: "block text-sm font-medium text-gray-700"
}, "Known as:", -1);
const _hoisted_66 = ["value", "disabled"];
const _hoisted_67 = { class: "mt-6" };
const _hoisted_68 = /*#__PURE__*/ _createElementVNode("label", {
    for: "middleName",
    class: "block text-sm font-medium text-gray-700"
}, "Middle Name:", -1);
const _hoisted_69 = ["value", "disabled"];
const _hoisted_70 = { class: "mt-6" };
const _hoisted_71 = /*#__PURE__*/ _createElementVNode("label", {
    for: "surname",
    class: "block text-sm font-medium text-gray-700"
}, "Surname *", -1);
const _hoisted_72 = ["value", "disabled"];
const _hoisted_73 = {
    key: 0,
    class: "text-red-500"
};
const _hoisted_74 = { class: "mt-6" };
const _hoisted_75 = /*#__PURE__*/ _createElementVNode("label", {
    for: "firstLine",
    class: "block text-sm font-medium text-gray-700"
}, "Home Address - 1st Line *", -1);
const _hoisted_76 = ["value", "disabled"];
const _hoisted_77 = {
    key: 0,
    class: "text-red-500"
};
const _hoisted_78 = { class: "mt-6" };
const _hoisted_79 = /*#__PURE__*/ _createElementVNode("label", {
    for: "secondLine",
    class: "block text-sm font-medium text-gray-700"
}, "Home Address - 2nd Line", -1);
const _hoisted_80 = ["value", "disabled"];
const _hoisted_81 = { class: "mt-6" };
const _hoisted_82 = /*#__PURE__*/ _createElementVNode("label", {
    for: "town",
    class: "block text-sm font-medium text-gray-700"
}, "Home Address - Town", -1);
const _hoisted_83 = ["value", "disabled"];
const _hoisted_84 = { class: "mt-6" };
const _hoisted_85 = /*#__PURE__*/ _createElementVNode("label", {
    for: "county",
    class: "block text-sm font-medium text-gray-700"
}, "Home Address - County *", -1);
const _hoisted_86 = ["value", "disabled"];
const _hoisted_87 = {
    key: 0,
    class: "text-red-500"
};
const _hoisted_88 = { class: "mt-6" };
const _hoisted_89 = /*#__PURE__*/ _createElementVNode("label", {
    for: "postcode",
    class: "block text-sm font-medium text-gray-700"
}, "Home Address - Postcode *", -1);
const _hoisted_90 = ["value", "disabled"];
const _hoisted_91 = {
    key: 0,
    class: "text-red-500"
};
const _hoisted_92 = /*#__PURE__*/ _createElementVNode("p", { class: "text-sm" }, [
    /*#__PURE__*/ _createTextVNode("* Please ensure the postcode is accurate and the correct format\n              has been used. You can access the\n              "),
    /*#__PURE__*/ _createElementVNode("a", {
        href: "https://www.royalmail.com/find-a-postcode",
        target: "_blank",
        class: "text-blue-600 hover:underline hover:font-bold"
    }, "Royal Mail Postcode Finder"),
    /*#__PURE__*/ _createTextVNode(".\n            ")
], -1);
const _hoisted_93 = { class: "mt-6" };
const _hoisted_94 = /*#__PURE__*/ _createElementVNode("label", {
    for: "email",
    class: "block text-sm font-medium text-gray-700"
}, "Email Address *", -1);
const _hoisted_95 = ["value", "disabled"];
const _hoisted_96 = {
    key: 0,
    class: "text-red-500"
};
const _hoisted_97 = { class: "mt-6" };
const _hoisted_98 = /*#__PURE__*/ _createElementVNode("label", {
    for: "homeTele",
    class: "block text-sm font-medium text-gray-700"
}, "Home Telephone Number *", -1);
const _hoisted_99 = ["value", "disabled"];
const _hoisted_100 = {
    key: 0,
    class: "text-red-500"
};
const _hoisted_101 = { class: "mt-6" };
const _hoisted_102 = /*#__PURE__*/ _createElementVNode("label", {
    for: "mobileTele",
    class: "block text-sm font-medium text-gray-700"
}, "Mobile Telephone Number *", -1);
const _hoisted_103 = ["value", "disabled"];
const _hoisted_104 = {
    key: 0,
    class: "text-red-500"
};
const _hoisted_105 = { key: 2 };
const _hoisted_106 = { class: "mt-6" };
const _hoisted_107 = /*#__PURE__*/ _createElementVNode("label", {
    for: "candidateEmployeeNumber",
    class: "block text-sm font-medium text-gray-700"
}, "What is the internal\n                candidates employee number? *", -1);
const _hoisted_108 = ["value", "disabled"];
const _hoisted_109 = {
    key: 0,
    class: "text-red-500"
};
const _hoisted_110 = { class: "mt-6" };
const _hoisted_111 = /*#__PURE__*/ _createElementVNode("label", {
    for: "internalCandidateName",
    class: "block text-sm font-medium text-gray-700"
}, "What is the internal\n                candidates name? *", -1);
const _hoisted_112 = ["value", "disabled"];
const _hoisted_113 = {
    key: 0,
    class: "text-red-500"
};
const _hoisted_114 = { class: "mt-6" };
const _hoisted_115 = /*#__PURE__*/ _createElementVNode("label", {
    for: "candidateCurrentSalaryRate",
    class: "block text-sm font-medium text-gray-700"
}, "What is the internal\n                candidates current salary or hourly rate? *", -1);
const _hoisted_116 = ["value", "disabled"];
const _hoisted_117 = {
    key: 0,
    class: "text-red-500"
};
const _hoisted_118 = { class: "flex items-start flex-col my-4" };
const _hoisted_119 = /*#__PURE__*/ _createElementVNode("p", null, "Is this in addition to the internal candidates existing role *", -1);
const _hoisted_120 = {
    key: 0,
    class: "text-red-500"
};
const _hoisted_121 = { class: "h-5 mt-4 flex items-center" };
const _hoisted_122 = ["disabled", "checked"];
const _hoisted_123 = /*#__PURE__*/ _createElementVNode("div", { class: "ml-3 text-sm" }, [
    /*#__PURE__*/ _createElementVNode("label", {
        for: "additionToExistingRole",
        class: "font-medium text-gray-700 cursor-pointer"
    }, "Yes")
], -1);
const _hoisted_124 = { class: "h-5 mt-4 flex items-center" };
const _hoisted_125 = ["disabled", "checked"];
const _hoisted_126 = /*#__PURE__*/ _createElementVNode("div", { class: "ml-3 text-sm" }, [
    /*#__PURE__*/ _createElementVNode("label", {
        for: "additionToExistingRole",
        class: "font-medium text-gray-700 cursor-pointer"
    }, "No")
], -1);
const _hoisted_127 = { class: "flex items-start flex-col my-4" };
const _hoisted_128 = /*#__PURE__*/ _createElementVNode("p", null, "Is this an internal promotion? *", -1);
const _hoisted_129 = {
    key: 0,
    class: "text-red-500"
};
const _hoisted_130 = { class: "h-5 mt-4 flex items-center" };
const _hoisted_131 = ["disabled", "checked"];
const _hoisted_132 = /*#__PURE__*/ _createElementVNode("div", { class: "ml-3 text-sm" }, [
    /*#__PURE__*/ _createElementVNode("label", {
        for: "promotion",
        class: "font-medium text-gray-700 cursor-pointer"
    }, "Yes")
], -1);
const _hoisted_133 = { class: "h-5 mt-4 flex items-center" };
const _hoisted_134 = ["disabled", "checked"];
const _hoisted_135 = /*#__PURE__*/ _createElementVNode("div", { class: "ml-3 text-sm" }, [
    /*#__PURE__*/ _createElementVNode("label", {
        for: "promotion",
        class: "font-medium text-gray-700 cursor-pointer"
    }, "No")
], -1);
const _hoisted_136 = { class: "flex items-start flex-col my-4" };
const _hoisted_137 = /*#__PURE__*/ _createElementVNode("p", null, "Is this a secondment? *", -1);
const _hoisted_138 = {
    key: 0,
    class: "text-red-500"
};
const _hoisted_139 = { class: "h-5 mt-4 flex items-center" };
const _hoisted_140 = ["disabled", "checked"];
const _hoisted_141 = /*#__PURE__*/ _createElementVNode("div", { class: "ml-3 text-sm" }, [
    /*#__PURE__*/ _createElementVNode("label", {
        for: "secondment",
        class: "font-medium text-gray-700 cursor-pointer"
    }, "Yes")
], -1);
const _hoisted_142 = { class: "h-5 mt-4 flex items-center" };
const _hoisted_143 = ["disabled", "checked"];
const _hoisted_144 = /*#__PURE__*/ _createElementVNode("div", { class: "ml-3 text-sm" }, [
    /*#__PURE__*/ _createElementVNode("label", {
        for: "secondment",
        class: "font-medium text-gray-700 cursor-pointer"
    }, "No")
], -1);
const _hoisted_145 = { class: "flex items-start flex-col my-4" };
const _hoisted_146 = /*#__PURE__*/ _createElementVNode("p", null, "Are you aware of any allowance that need to be ended in the employees previous role? *", -1);
const _hoisted_147 = {
    key: 0,
    class: "text-red-500"
};
const _hoisted_148 = { class: "h-5 mt-4 flex items-center" };
const _hoisted_149 = ["disabled", "checked"];
const _hoisted_150 = /*#__PURE__*/ _createElementVNode("div", { class: "ml-3 text-sm" }, [
    /*#__PURE__*/ _createElementVNode("label", {
        for: "existingAllowance",
        class: "font-medium text-gray-700 cursor-pointer"
    }, "Yes")
], -1);
const _hoisted_151 = { class: "h-5 mt-4 flex items-center" };
const _hoisted_152 = ["disabled", "checked"];
const _hoisted_153 = /*#__PURE__*/ _createElementVNode("div", { class: "ml-3 text-sm" }, [
    /*#__PURE__*/ _createElementVNode("label", {
        for: "existingAllowance",
        class: "font-medium text-gray-700 cursor-pointer"
    }, "No")
], -1);
const _hoisted_154 = { key: 0 };
const _hoisted_155 = { class: "col-span-6" };
const _hoisted_156 = { class: "flex justify-between" };
const _hoisted_157 = /*#__PURE__*/ _createElementVNode("label", {
    for: "existingAllowanceName",
    class: "block text-sm font-medium text-gray-700"
}, "Allowance Name\n                      *", -1);
const _hoisted_158 = ["value", "disabled", "onInput"];
const _hoisted_159 = { class: "flex items-start flex-col my-2" };
const _hoisted_160 = /*#__PURE__*/ _createElementVNode("label", {
    for: "existingAllowanceAmount",
    class: "block text-sm font-medium text-gray-700"
}, "Allowance Amount\n                    *", -1);
const _hoisted_161 = ["value", "disabled", "onInput"];
const _hoisted_162 = { class: "flex justify-end mt-4" };
const _hoisted_163 = /*#__PURE__*/ _createStaticVNode("<div class=\"mt-8\"><h3 class=\"text-lg my-2\">Right To Work</h3> <p class=\"my-2 text-sm font-medium text-gray-700\">New starters to the business:</p> <p class=\"my-2 text-sm font-medium text-gray-700\">\n              Recruitment is a legal process so all relevant documentation must be completed and correct.\n              If not a contract cannot be issued and the new starter will not be paid.\n            </p> <p class=\"my-2 text-sm font-medium text-gray-700\">\n              I confirm that the following attachments have been included:\n            <ul class=\"list-disc list-inside marker:text-black\"><li class=\"text-sm font-medium text-gray-700\">Verified and signed copy of Right to Work in the UK or where\n                applicable proof of an online check via the Home Office online service</li> <li class=\"text-sm font-medium text-gray-700\">Proof of their identity (usually a passport) to support Home\n                Office online check</li> <li class=\"text-sm font-medium text-gray-700\">Candidate&#39;s CV</li> <li class=\"text-sm font-medium text-gray-700\">Job Description</li></ul></p> <p class=\"my-2 text-sm font-medium text-gray-700\">Policy (LINK)</p> <p class=\"my-2 text-sm font-medium text-gray-700\">You must have had sight of the original Right to Work\n              document. You should take a copy and write on each copy: “I certify that this is a true\n              copy of the original”, then sign, print your name, note your job title, and date the copy.\n            </p> <p class=\"my-2 text-sm font-medium text-gray-700\">\n              For EEA Nationals you will need to check proof of their immigration status – either (i) proof of their EEA\n              Settled status – this has to be done\n              via the Home Office online service through the provision of a share code; or (ii) if they meet the new\n              requirements of the immigration system.\n            </p> <p class=\"my-2 text-sm font-medium text-gray-700\">Please be sure to check the Right to Work Policy to ensure\n              you have provided the correct documentation. The Offer will be rejected if the\n              incorrect documentation is provided.\n            </p> <p class=\"my-2 text-sm font-medium text-gray-700\">Tips to avoid Right to Work rejections:</p> <p class=\"my-2 text-sm font-medium text-gray-700\">Right to work evidence must be verified with the\n              certification statement above, signature, printed name, and date.</p> <p class=\"my-2 text-sm font-medium text-gray-700\">\n              Where an employee has submitted evidence of their National Insurance Number and their Birth Certificate as\n              their Right to Work evidence,\n              they must submit their full birth certificate showing at least one parent’s details.\n            </p> <p class=\"my-2 text-sm font-medium text-gray-700\">You must also provide proof of the National Insurance Number\n              or an official document showing the National Insurance Number</p> <p class=\"my-2 text-sm font-medium text-gray-700\">Where an employee has provided a Biometric Card you should\n              take copies of the front and back of the Biometric Card (Biometric Residence Permit).</p> <p class=\"my-2 text-sm font-medium text-gray-700\">\n              The names on all documentation must match, e.g. if passport or biometric card is in their maiden name, then\n              the employee must submit their marriage\n              certificate to show the name change.\n            </p> <p class=\"my-2 text-sm font-medium text-gray-700\">\n              Evidence of an Home Office online check being completed (where applicable). Watch the Right to Work\n              presentation here. Internal appointments:\n              Right to work documentation will already be on file for the employee, therefore only the new job description\n              is required. Once ready, please scan and\n              attach the copies below.\n            </p> <p class=\"my-2 text-sm font-medium text-gray-700\">Internal appointments</p> <p class=\"my-2 text-sm font-medium text-gray-700\">Right to work documentation will already be on file for the\n              employee, therefore only the new job description is required.</p></div>", 1);
const _hoisted_164 = /*#__PURE__*/ _createElementVNode("p", { class: "my-2 text-sm font-medium text-gray-700" }, "Please upload any right to work documents here:", -1);
const _hoisted_165 = {
    key: 0,
    class: "px-4 py-3 bg-gray-50 text-right sm:px-6"
};
const _hoisted_166 = ["disabled"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_XIcon = _resolveComponent("XIcon");
    const _component_FileUploader = _resolveComponent("FileUploader");
    return (_openBlock(), _createElementBlock("form", null, [
        _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
                _hoisted_3,
                _createTextVNode(),
                _createElementVNode("div", null, [
                    _createElementVNode("div", _hoisted_4, [
                        _hoisted_5,
                        _createTextVNode(),
                        (_ctx.v$.formData.directReports.$error)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_6, "\n              * " + _toDisplayString(_ctx.v$.formData.directReports.$errors[0].$message), 1))
                            : _createCommentVNode("", true),
                        _createTextVNode(),
                        _createElementVNode("div", _hoisted_7, [
                            _createElementVNode("div", null, [
                                _createElementVNode("input", {
                                    id: "radio_button_direct_reports_Yes",
                                    value: "Yes",
                                    name: "directReports",
                                    type: "radio",
                                    class: "focus:ring-indigo-500 h-4 w-4 text-indigo-600 border-gray-300 rounded cursor-pointer disabled:bg-gray-200 disabled:border-none disabled:cursor-not-allowed",
                                    disabled: _ctx.disableForm,
                                    checked: _ctx.formData?.directReports === 'Yes',
                                    onChange: _cache[0] || (_cache[0] =
                                        //@ts-ignore
                                        (...args) => (_ctx.handleInput && _ctx.handleInput(...args))),
                                    onBlur: _cache[1] || (_cache[1] = ($event) => (_ctx.v$.formData.directReports.$touch()))
                                }, null, 40, _hoisted_8)
                            ]),
                            _createTextVNode(),
                            _hoisted_9
                        ]),
                        _createTextVNode(),
                        _createElementVNode("div", _hoisted_10, [
                            _createElementVNode("div", null, [
                                _createElementVNode("input", {
                                    id: "radio_button_direct_reports_No",
                                    value: "No",
                                    name: "directReports",
                                    type: "radio",
                                    class: "focus:ring-indigo-500 h-4 w-4 text-indigo-600 border-gray-300 rounded cursor-pointer disabled:bg-gray-200 disabled:border-none disabled:cursor-not-allowed",
                                    disabled: _ctx.disableForm,
                                    checked: _ctx.formData?.directReports === 'No',
                                    onChange: _cache[2] || (_cache[2] =
                                        //@ts-ignore
                                        (...args) => (_ctx.handleInput && _ctx.handleInput(...args))),
                                    onBlur: _cache[3] || (_cache[3] = ($event) => (_ctx.v$.formData.directReports.$touch()))
                                }, null, 40, _hoisted_11)
                            ]),
                            _createTextVNode(),
                            _hoisted_12
                        ])
                    ]),
                    _createTextVNode(),
                    (_ctx.formData?.directReports === 'Yes')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                            _hoisted_14,
                            _createTextVNode(),
                            _createElementVNode("input", {
                                value: _ctx.formData?.directReportsInfo,
                                type: "text",
                                name: "directReportsInfo",
                                class: "mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border border-gray-300 rounded-md disabled:cursor-not-allowed disabled:bg-gray-200 disabled:cursor-not-allowed",
                                disabled: _ctx.disableForm,
                                onInput: _cache[4] || (_cache[4] =
                                    //@ts-ignore
                                    (...args) => (_ctx.handleInput && _ctx.handleInput(...args))),
                                onBlur: _cache[5] || (_cache[5] = ($event) => (_ctx.v$.formData.directReportsInfo.$touch()))
                            }, null, 40, _hoisted_15),
                            _createTextVNode(),
                            (_ctx.v$.formData.directReportsInfo.$error)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_16, "\n              * " + _toDisplayString(_ctx.v$.formData.directReportsInfo.$errors[0].$message), 1))
                                : _createCommentVNode("", true)
                        ]))
                        : _createCommentVNode("", true),
                    _createTextVNode(),
                    _createElementVNode("div", _hoisted_17, [
                        _hoisted_18,
                        _createTextVNode(),
                        (_ctx.v$.formData.internal_candidate.$error)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_19, "\n              * " + _toDisplayString(_ctx.v$.formData.internal_candidate.$errors[0].$message), 1))
                            : _createCommentVNode("", true),
                        _createTextVNode(),
                        _createElementVNode("div", _hoisted_20, [
                            _createElementVNode("div", null, [
                                _createElementVNode("input", {
                                    id: "radio_button_internal_candidate_Yes",
                                    value: "Yes",
                                    name: "internal_candidate",
                                    type: "radio",
                                    class: "focus:ring-indigo-500 h-4 w-4 text-indigo-600 border-gray-300 rounded cursor-pointer disabled:bg-gray-200 disabled:border-none disabled:cursor-not-allowed",
                                    disabled: _ctx.disableForm,
                                    checked: _ctx.formData?.internal_candidate === 'Yes',
                                    onChange: _cache[6] || (_cache[6] =
                                        //@ts-ignore
                                        (...args) => (_ctx.handleInput && _ctx.handleInput(...args))),
                                    onBlur: _cache[7] || (_cache[7] = ($event) => (_ctx.v$.formData.internal_candidate.$touch()))
                                }, null, 40, _hoisted_21)
                            ]),
                            _createTextVNode(),
                            _hoisted_22
                        ]),
                        _createTextVNode(),
                        _createElementVNode("div", _hoisted_23, [
                            _createElementVNode("div", null, [
                                _createElementVNode("input", {
                                    id: "radio_button_internal_candidate_No",
                                    value: "No",
                                    name: "internal_candidate",
                                    type: "radio",
                                    class: "focus:ring-indigo-500 h-4 w-4 text-indigo-600 border-gray-300 rounded cursor-pointer disabled:bg-gray-200 disabled:border-none disabled:cursor-not-allowed",
                                    disabled: _ctx.disableForm,
                                    checked: _ctx.formData?.internal_candidate === 'No',
                                    onChange: _cache[8] || (_cache[8] =
                                        //@ts-ignore
                                        (...args) => (_ctx.handleInput && _ctx.handleInput(...args))),
                                    onBlur: _cache[9] || (_cache[9] = ($event) => (_ctx.v$.formData.internal_candidate.$touch()))
                                }, null, 40, _hoisted_24)
                            ]),
                            _createTextVNode(),
                            _hoisted_25
                        ])
                    ]),
                    _createTextVNode(),
                    (_ctx.formData?.internal_candidate === 'No')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                            _createElementVNode("div", _hoisted_27, [
                                _hoisted_28,
                                _createTextVNode(),
                                (_ctx.v$.formData.transferring.$error)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_29, "\n                * " + _toDisplayString(_ctx.v$.formData.transferring.$errors[0].$message), 1))
                                    : _createCommentVNode("", true),
                                _createTextVNode(),
                                _createElementVNode("div", _hoisted_30, [
                                    _createElementVNode("div", null, [
                                        _createElementVNode("input", {
                                            id: "radio_button_transferring_Yes",
                                            value: "Yes",
                                            name: "transferring",
                                            type: "radio",
                                            class: "focus:ring-indigo-500 h-4 w-4 text-indigo-600 border-gray-300 rounded cursor-pointer disabled:bg-gray-200 disabled:border-none disabled:cursor-not-allowed",
                                            disabled: _ctx.disableForm,
                                            checked: _ctx.formData?.transferring === 'Yes',
                                            onChange: _cache[10] || (_cache[10] =
                                                //@ts-ignore
                                                (...args) => (_ctx.handleInput && _ctx.handleInput(...args))),
                                            onBlur: _cache[11] || (_cache[11] = ($event) => (_ctx.v$.formData.transferring.$touch()))
                                        }, null, 40, _hoisted_31)
                                    ]),
                                    _createTextVNode(),
                                    _hoisted_32
                                ]),
                                _createTextVNode(),
                                _createElementVNode("div", _hoisted_33, [
                                    _createElementVNode("div", null, [
                                        _createElementVNode("input", {
                                            id: "radio_button_transferrings_No",
                                            value: "No",
                                            name: "transferring",
                                            type: "radio",
                                            class: "focus:ring-indigo-500 h-4 w-4 text-indigo-600 border-gray-300 rounded cursor-pointer disabled:bg-gray-200 disabled:border-none disabled:cursor-not-allowed",
                                            disabled: _ctx.disableForm,
                                            checked: _ctx.formData?.transferring === 'No',
                                            onChange: _cache[12] || (_cache[12] =
                                                //@ts-ignore
                                                (...args) => (_ctx.handleInput && _ctx.handleInput(...args))),
                                            onBlur: _cache[13] || (_cache[13] = ($event) => (_ctx.v$.formData.transferring.$touch()))
                                        }, null, 40, _hoisted_34)
                                    ]),
                                    _createTextVNode(),
                                    _hoisted_35
                                ])
                            ]),
                            _createTextVNode(),
                            _createElementVNode("div", _hoisted_36, [
                                _hoisted_37,
                                _createTextVNode(),
                                (_ctx.v$.formData.tempTermProcess.$error)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_38, "\n                * " + _toDisplayString(_ctx.v$.formData.tempTermProcess.$errors[0].$message), 1))
                                    : _createCommentVNode("", true),
                                _createTextVNode(),
                                _createElementVNode("div", _hoisted_39, [
                                    _createElementVNode("div", null, [
                                        _createElementVNode("input", {
                                            id: "radio_button_temp_perm_process_Yes",
                                            value: "Yes",
                                            name: "tempTermProcess",
                                            type: "radio",
                                            class: "focus:ring-indigo-500 h-4 w-4 text-indigo-600 border-gray-300 rounded cursor-pointer disabled:bg-gray-200 disabled:border-none disabled:cursor-not-allowed",
                                            disabled: _ctx.disableForm,
                                            checked: _ctx.formData?.tempTermProcess === 'Yes',
                                            onChange: _cache[14] || (_cache[14] =
                                                //@ts-ignore
                                                (...args) => (_ctx.handleInput && _ctx.handleInput(...args))),
                                            onBlur: _cache[15] || (_cache[15] = ($event) => (_ctx.v$.formData.tempTermProcess.$touch()))
                                        }, null, 40, _hoisted_40)
                                    ]),
                                    _createTextVNode(),
                                    _hoisted_41
                                ]),
                                _createTextVNode(),
                                _createElementVNode("div", _hoisted_42, [
                                    _createElementVNode("div", null, [
                                        _createElementVNode("input", {
                                            id: "radio_button_temp_perm_process_No",
                                            value: "No",
                                            name: "tempTermProcess",
                                            type: "radio",
                                            class: "focus:ring-indigo-500 h-4 w-4 text-indigo-600 border-gray-300 rounded cursor-pointer disabled:bg-gray-200 disabled:border-none disabled:cursor-not-allowed",
                                            disabled: _ctx.disableForm,
                                            checked: _ctx.formData?.tempTermProcess === 'No',
                                            onChange: _cache[16] || (_cache[16] =
                                                //@ts-ignore
                                                (...args) => (_ctx.handleInput && _ctx.handleInput(...args))),
                                            onBlur: _cache[17] || (_cache[17] = ($event) => (_ctx.v$.formData.tempTermProcess.$touch()))
                                        }, null, 40, _hoisted_43)
                                    ]),
                                    _createTextVNode(),
                                    _hoisted_44
                                ])
                            ]),
                            _createTextVNode(),
                            _createElementVNode("div", _hoisted_45, [
                                _hoisted_46,
                                _createTextVNode(),
                                _createElementVNode("input", {
                                    value: _ctx.formData?.d59Number,
                                    type: "text",
                                    name: "d59Number",
                                    class: "mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border border-gray-300 rounded-md disabled:cursor-not-allowed disabled:bg-gray-200 disabled:cursor-not-allowed",
                                    disabled: _ctx.disableForm,
                                    onInput: _cache[18] || (_cache[18] =
                                        //@ts-ignore
                                        (...args) => (_ctx.handleInput && _ctx.handleInput(...args)))
                                }, null, 40, _hoisted_47)
                            ]),
                            _createTextVNode(),
                            _hoisted_48,
                            _createTextVNode(),
                            _createElementVNode("div", _hoisted_49, [
                                _createElementVNode("div", _hoisted_50, [
                                    _hoisted_51,
                                    _createTextVNode(),
                                    _createElementVNode("select", {
                                        id: "title",
                                        value: _ctx.formData.title,
                                        name: "title",
                                        autocomplete: "title",
                                        class: "mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border-gray-300 rounded-md",
                                        onInput: _cache[19] || (_cache[19] =
                                            //@ts-ignore
                                            (...args) => (_ctx.handleInput && _ctx.handleInput(...args))),
                                        onBlur: _cache[20] || (_cache[20] = ($event) => (_ctx.v$.formData.title.$touch()))
                                    }, [
                                        _hoisted_53,
                                        _createTextVNode(),
                                        _hoisted_54,
                                        _createTextVNode(),
                                        _hoisted_55,
                                        _createTextVNode(),
                                        _hoisted_56,
                                        _createTextVNode(),
                                        _hoisted_57,
                                        _createTextVNode(),
                                        _hoisted_58
                                    ], 40, _hoisted_52),
                                    _createTextVNode(),
                                    (_ctx.v$.formData.title.$error)
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_59, "\n                  * " + _toDisplayString(_ctx.v$.formData.title.$errors[0].$message), 1))
                                        : _createCommentVNode("", true)
                                ])
                            ]),
                            _createTextVNode(),
                            _createElementVNode("div", _hoisted_60, [
                                _hoisted_61,
                                _createTextVNode(),
                                _createElementVNode("input", {
                                    value: _ctx.formData?.firstName,
                                    type: "text",
                                    name: "firstName",
                                    class: "mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border border-gray-300 rounded-md disabled:cursor-not-allowed disabled:bg-gray-200 disabled:cursor-not-allowed",
                                    disabled: _ctx.disableForm,
                                    onInput: _cache[21] || (_cache[21] =
                                        //@ts-ignore
                                        (...args) => (_ctx.handleInput && _ctx.handleInput(...args))),
                                    onBlur: _cache[22] || (_cache[22] = ($event) => (_ctx.v$.formData.firstName.$touch()))
                                }, null, 40, _hoisted_62),
                                _createTextVNode(),
                                (_ctx.v$.formData.firstName.$error)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_63, "\n                * " + _toDisplayString(_ctx.v$.formData.firstName.$errors[0].$message), 1))
                                    : _createCommentVNode("", true)
                            ]),
                            _createTextVNode(),
                            _createElementVNode("div", _hoisted_64, [
                                _hoisted_65,
                                _createTextVNode(),
                                _createElementVNode("input", {
                                    value: _ctx.formData?.knownAs,
                                    type: "text",
                                    name: "knownAs",
                                    class: "mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border border-gray-300 rounded-md disabled:cursor-not-allowed disabled:bg-gray-200 disabled:cursor-not-allowed",
                                    disabled: _ctx.disableForm,
                                    onInput: _cache[23] || (_cache[23] =
                                        //@ts-ignore
                                        (...args) => (_ctx.handleInput && _ctx.handleInput(...args)))
                                }, null, 40, _hoisted_66)
                            ]),
                            _createTextVNode(),
                            _createElementVNode("div", _hoisted_67, [
                                _hoisted_68,
                                _createTextVNode(),
                                _createElementVNode("input", {
                                    value: _ctx.formData?.middleName,
                                    type: "text",
                                    name: "middleName",
                                    class: "mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border border-gray-300 rounded-md disabled:cursor-not-allowed disabled:bg-gray-200 disabled:cursor-not-allowed",
                                    disabled: _ctx.disableForm,
                                    onInput: _cache[24] || (_cache[24] =
                                        //@ts-ignore
                                        (...args) => (_ctx.handleInput && _ctx.handleInput(...args)))
                                }, null, 40, _hoisted_69)
                            ]),
                            _createTextVNode(),
                            _createElementVNode("div", _hoisted_70, [
                                _hoisted_71,
                                _createTextVNode(),
                                _createElementVNode("input", {
                                    value: _ctx.formData?.surname,
                                    type: "text",
                                    name: "surname",
                                    class: "mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border border-gray-300 rounded-md disabled:cursor-not-allowed disabled:bg-gray-200 disabled:cursor-not-allowed",
                                    disabled: _ctx.disableForm,
                                    onInput: _cache[25] || (_cache[25] =
                                        //@ts-ignore
                                        (...args) => (_ctx.handleInput && _ctx.handleInput(...args))),
                                    onBlur: _cache[26] || (_cache[26] = ($event) => (_ctx.v$.formData.surname.$touch()))
                                }, null, 40, _hoisted_72),
                                _createTextVNode(),
                                (_ctx.v$.formData.surname.$error)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_73, "\n                * " + _toDisplayString(_ctx.v$.formData.surname.$errors[0].$message), 1))
                                    : _createCommentVNode("", true)
                            ]),
                            _createTextVNode(),
                            _createElementVNode("div", _hoisted_74, [
                                _hoisted_75,
                                _createTextVNode(),
                                _createElementVNode("input", {
                                    value: _ctx.formData?.firstLine,
                                    type: "text",
                                    name: "firstLine",
                                    class: "mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border border-gray-300 rounded-md disabled:cursor-not-allowed disabled:bg-gray-200 disabled:cursor-not-allowed",
                                    disabled: _ctx.disableForm,
                                    onInput: _cache[27] || (_cache[27] =
                                        //@ts-ignore
                                        (...args) => (_ctx.handleInput && _ctx.handleInput(...args))),
                                    onBlur: _cache[28] || (_cache[28] = ($event) => (_ctx.v$.formData.firstLine.$touch()))
                                }, null, 40, _hoisted_76),
                                _createTextVNode(),
                                (_ctx.v$.formData.firstLine.$error)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_77, "\n                * " + _toDisplayString(_ctx.v$.formData.firstLine.$errors[0].$message), 1))
                                    : _createCommentVNode("", true)
                            ]),
                            _createTextVNode(),
                            _createElementVNode("div", _hoisted_78, [
                                _hoisted_79,
                                _createTextVNode(),
                                _createElementVNode("input", {
                                    value: _ctx.formData?.secondLine,
                                    type: "text",
                                    name: "secondLine",
                                    class: "mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border border-gray-300 rounded-md disabled:cursor-not-allowed disabled:bg-gray-200 disabled:cursor-not-allowed",
                                    disabled: _ctx.disableForm,
                                    onInput: _cache[29] || (_cache[29] =
                                        //@ts-ignore
                                        (...args) => (_ctx.handleInput && _ctx.handleInput(...args)))
                                }, null, 40, _hoisted_80)
                            ]),
                            _createTextVNode(),
                            _createElementVNode("div", _hoisted_81, [
                                _hoisted_82,
                                _createTextVNode(),
                                _createElementVNode("input", {
                                    value: _ctx.formData?.town,
                                    type: "text",
                                    name: "town",
                                    class: "mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border border-gray-300 rounded-md disabled:cursor-not-allowed disabled:bg-gray-200 disabled:cursor-not-allowed",
                                    disabled: _ctx.disableForm,
                                    onInput: _cache[30] || (_cache[30] =
                                        //@ts-ignore
                                        (...args) => (_ctx.handleInput && _ctx.handleInput(...args)))
                                }, null, 40, _hoisted_83)
                            ]),
                            _createTextVNode(),
                            _createElementVNode("div", _hoisted_84, [
                                _hoisted_85,
                                _createTextVNode(),
                                _createElementVNode("input", {
                                    value: _ctx.formData?.county,
                                    type: "text",
                                    name: "county",
                                    class: "mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border border-gray-300 rounded-md disabled:cursor-not-allowed disabled:bg-gray-200 disabled:cursor-not-allowed",
                                    disabled: _ctx.disableForm,
                                    onInput: _cache[31] || (_cache[31] =
                                        //@ts-ignore
                                        (...args) => (_ctx.handleInput && _ctx.handleInput(...args))),
                                    onBlur: _cache[32] || (_cache[32] = ($event) => (_ctx.v$.formData.county.$touch()))
                                }, null, 40, _hoisted_86),
                                _createTextVNode(),
                                (_ctx.v$.formData.county.$error)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_87, "\n                * " + _toDisplayString(_ctx.v$.formData.county.$errors[0].$message), 1))
                                    : _createCommentVNode("", true)
                            ]),
                            _createTextVNode(),
                            _createElementVNode("div", _hoisted_88, [
                                _hoisted_89,
                                _createTextVNode(),
                                _createElementVNode("input", {
                                    value: _ctx.formData?.postcode,
                                    type: "text",
                                    name: "postcode",
                                    class: "mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border border-gray-300 rounded-md disabled:cursor-not-allowed disabled:bg-gray-200 disabled:cursor-not-allowed",
                                    disabled: _ctx.disableForm,
                                    onInput: _cache[33] || (_cache[33] =
                                        //@ts-ignore
                                        (...args) => (_ctx.handleInput && _ctx.handleInput(...args))),
                                    onBlur: _cache[34] || (_cache[34] = ($event) => (_ctx.v$.formData.postcode.$touch()))
                                }, null, 40, _hoisted_90),
                                _createTextVNode(),
                                (_ctx.v$.formData.postcode.$error)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_91, "\n                * " + _toDisplayString(_ctx.v$.formData.postcode.$errors[0].$message), 1))
                                    : _createCommentVNode("", true)
                            ]),
                            _createTextVNode(),
                            _hoisted_92,
                            _createTextVNode(),
                            _createElementVNode("div", _hoisted_93, [
                                _hoisted_94,
                                _createTextVNode(),
                                _createElementVNode("input", {
                                    value: _ctx.formData?.email,
                                    type: "text",
                                    name: "email",
                                    class: "mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border border-gray-300 rounded-md disabled:cursor-not-allowed disabled:bg-gray-200 disabled:cursor-not-allowed",
                                    disabled: _ctx.disableForm,
                                    onInput: _cache[35] || (_cache[35] =
                                        //@ts-ignore
                                        (...args) => (_ctx.handleInput && _ctx.handleInput(...args))),
                                    onBlur: _cache[36] || (_cache[36] = ($event) => (_ctx.v$.formData.email.$touch()))
                                }, null, 40, _hoisted_95),
                                _createTextVNode(),
                                (_ctx.v$.formData.email.$error)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_96, "\n                * " + _toDisplayString(_ctx.v$.formData.email.$errors[0].$message), 1))
                                    : _createCommentVNode("", true)
                            ]),
                            _createTextVNode(),
                            _createElementVNode("div", _hoisted_97, [
                                _hoisted_98,
                                _createTextVNode(),
                                _createElementVNode("input", {
                                    value: _ctx.formData?.homeTele,
                                    type: "text",
                                    name: "homeTele",
                                    class: "mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border border-gray-300 rounded-md disabled:cursor-not-allowed disabled:bg-gray-200 disabled:cursor-not-allowed",
                                    disabled: _ctx.disableForm,
                                    onInput: _cache[37] || (_cache[37] =
                                        //@ts-ignore
                                        (...args) => (_ctx.handleInput && _ctx.handleInput(...args))),
                                    onBlur: _cache[38] || (_cache[38] = ($event) => (_ctx.v$.formData.homeTele.$touch()))
                                }, null, 40, _hoisted_99),
                                _createTextVNode(),
                                (_ctx.v$.formData.homeTele.$error)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_100, "\n                * " + _toDisplayString(_ctx.v$.formData.homeTele.$errors[0].$message), 1))
                                    : _createCommentVNode("", true)
                            ]),
                            _createTextVNode(),
                            _createElementVNode("div", _hoisted_101, [
                                _hoisted_102,
                                _createTextVNode(),
                                _createElementVNode("input", {
                                    value: _ctx.formData?.mobileTele,
                                    type: "text",
                                    name: "mobileTele",
                                    class: "mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border border-gray-300 rounded-md disabled:cursor-not-allowed disabled:bg-gray-200 disabled:cursor-not-allowed",
                                    disabled: _ctx.disableForm,
                                    onInput: _cache[39] || (_cache[39] =
                                        //@ts-ignore
                                        (...args) => (_ctx.handleInput && _ctx.handleInput(...args))),
                                    onBlur: _cache[40] || (_cache[40] = ($event) => (_ctx.v$.formData.mobileTele.$touch()))
                                }, null, 40, _hoisted_103),
                                _createTextVNode(),
                                (_ctx.v$.formData.mobileTele.$error)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_104, "\n                * " + _toDisplayString(_ctx.v$.formData.mobileTele.$errors[0].$message), 1))
                                    : _createCommentVNode("", true)
                            ])
                        ]))
                        : _createCommentVNode("", true),
                    _createTextVNode(),
                    (_ctx.formData?.internal_candidate === 'Yes')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_105, [
                            _createElementVNode("div", _hoisted_106, [
                                _hoisted_107,
                                _createTextVNode(),
                                _createElementVNode("input", {
                                    value: _ctx.formData?.candidateEmployeeNumber,
                                    type: "text",
                                    name: "candidateEmployeeNumber",
                                    class: "mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border border-gray-300 rounded-md disabled:cursor-not-allowed disabled:bg-gray-200 disabled:cursor-not-allowed",
                                    disabled: _ctx.disableForm,
                                    onInput: _cache[41] || (_cache[41] =
                                        //@ts-ignore
                                        (...args) => (_ctx.handleInput && _ctx.handleInput(...args))),
                                    onBlur: _cache[42] || (_cache[42] = ($event) => (_ctx.v$.formData.candidateEmployeeNumber.$touch()))
                                }, null, 40, _hoisted_108),
                                _createTextVNode(),
                                (_ctx.v$.formData.candidateEmployeeNumber.$error)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_109, "\n                * " + _toDisplayString(_ctx.v$.formData.candidateEmployeeNumber.$errors[0].$message), 1))
                                    : _createCommentVNode("", true)
                            ]),
                            _createTextVNode(),
                            _createElementVNode("div", _hoisted_110, [
                                _hoisted_111,
                                _createTextVNode(),
                                _createElementVNode("input", {
                                    value: _ctx.formData?.internalCandidateName,
                                    type: "text",
                                    name: "internalCandidateName",
                                    class: "mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border border-gray-300 rounded-md disabled:cursor-not-allowed disabled:bg-gray-200 disabled:cursor-not-allowed",
                                    disabled: _ctx.disableForm,
                                    onInput: _cache[43] || (_cache[43] =
                                        //@ts-ignore
                                        (...args) => (_ctx.handleInput && _ctx.handleInput(...args))),
                                    onBlur: _cache[44] || (_cache[44] = ($event) => (_ctx.v$.formData.internalCandidateName.$touch()))
                                }, null, 40, _hoisted_112),
                                _createTextVNode(),
                                (_ctx.v$.formData.internalCandidateName.$error)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_113, "\n                * " + _toDisplayString(_ctx.v$.formData.internalCandidateName.$errors[0].$message), 1))
                                    : _createCommentVNode("", true)
                            ]),
                            _createTextVNode(),
                            _createElementVNode("div", _hoisted_114, [
                                _hoisted_115,
                                _createTextVNode(),
                                _createElementVNode("input", {
                                    value: _ctx.formData?.candidateCurrentSalaryRate,
                                    type: "number",
                                    min: "0",
                                    name: "candidateCurrentSalaryRate",
                                    class: "mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border border-gray-300 rounded-md disabled:cursor-not-allowed disabled:bg-gray-200 disabled:cursor-not-allowed",
                                    disabled: _ctx.disableForm,
                                    onInput: _cache[45] || (_cache[45] =
                                        //@ts-ignore
                                        (...args) => (_ctx.handleInput && _ctx.handleInput(...args))),
                                    onBlur: _cache[46] || (_cache[46] = ($event) => (_ctx.v$.formData.candidateCurrentSalaryRate.$touch()))
                                }, null, 40, _hoisted_116),
                                _createTextVNode(),
                                (_ctx.v$.formData.candidateCurrentSalaryRate.$error)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_117, "\n                * " + _toDisplayString(_ctx.v$.formData.candidateCurrentSalaryRate.$errors[0].$message), 1))
                                    : _createCommentVNode("", true)
                            ]),
                            _createTextVNode(),
                            _createElementVNode("div", _hoisted_118, [
                                _hoisted_119,
                                _createTextVNode(),
                                (_ctx.v$.formData.additionToExistingRole.$error)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_120, "\n                * " + _toDisplayString(_ctx.v$.formData.additionToExistingRole.$errors[0].$message), 1))
                                    : _createCommentVNode("", true),
                                _createTextVNode(),
                                _createElementVNode("div", _hoisted_121, [
                                    _createElementVNode("div", null, [
                                        _createElementVNode("input", {
                                            id: "radio_button_additionToExistingRole_Yes",
                                            value: "Yes",
                                            name: "additionToExistingRole",
                                            type: "radio",
                                            class: "focus:ring-indigo-500 h-4 w-4 text-indigo-600 border-gray-300 rounded cursor-pointer disabled:bg-gray-200 disabled:border-none disabled:cursor-not-allowed",
                                            disabled: _ctx.disableForm,
                                            checked: _ctx.formData?.additionToExistingRole === 'Yes',
                                            onChange: _cache[47] || (_cache[47] =
                                                //@ts-ignore
                                                (...args) => (_ctx.handleInput && _ctx.handleInput(...args))),
                                            onBlur: _cache[48] || (_cache[48] = ($event) => (_ctx.v$.formData.additionToExistingRole.$touch()))
                                        }, null, 40, _hoisted_122)
                                    ]),
                                    _createTextVNode(),
                                    _hoisted_123
                                ]),
                                _createTextVNode(),
                                _createElementVNode("div", _hoisted_124, [
                                    _createElementVNode("div", null, [
                                        _createElementVNode("input", {
                                            id: "radio_button_additionToExistingRole_No",
                                            value: "No",
                                            name: "additionToExistingRole",
                                            type: "radio",
                                            class: "focus:ring-indigo-500 h-4 w-4 text-indigo-600 border-gray-300 rounded cursor-pointer disabled:bg-gray-200 disabled:border-none disabled:cursor-not-allowed",
                                            disabled: _ctx.disableForm,
                                            checked: _ctx.formData?.additionToExistingRole === 'No',
                                            onChange: _cache[49] || (_cache[49] =
                                                //@ts-ignore
                                                (...args) => (_ctx.handleInput && _ctx.handleInput(...args))),
                                            onBlur: _cache[50] || (_cache[50] = ($event) => (_ctx.v$.formData.additionToExistingRole.$touch()))
                                        }, null, 40, _hoisted_125)
                                    ]),
                                    _createTextVNode(),
                                    _hoisted_126
                                ])
                            ]),
                            _createTextVNode(),
                            _createElementVNode("div", _hoisted_127, [
                                _hoisted_128,
                                _createTextVNode(),
                                (_ctx.v$.formData.promotion.$error)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_129, "\n                * " + _toDisplayString(_ctx.v$.formData.promotion.$errors[0].$message), 1))
                                    : _createCommentVNode("", true),
                                _createTextVNode(),
                                _createElementVNode("div", _hoisted_130, [
                                    _createElementVNode("div", null, [
                                        _createElementVNode("input", {
                                            id: "radio_button_promotion_Yes",
                                            value: "Yes",
                                            name: "promotion",
                                            type: "radio",
                                            class: "focus:ring-indigo-500 h-4 w-4 text-indigo-600 border-gray-300 rounded cursor-pointer disabled:bg-gray-200 disabled:border-none disabled:cursor-not-allowed",
                                            disabled: _ctx.disableForm,
                                            checked: _ctx.formData?.promotion === 'Yes',
                                            onChange: _cache[51] || (_cache[51] =
                                                //@ts-ignore
                                                (...args) => (_ctx.handleInput && _ctx.handleInput(...args))),
                                            onBlur: _cache[52] || (_cache[52] = ($event) => (_ctx.v$.formData.promotion.$touch()))
                                        }, null, 40, _hoisted_131)
                                    ]),
                                    _createTextVNode(),
                                    _hoisted_132
                                ]),
                                _createTextVNode(),
                                _createElementVNode("div", _hoisted_133, [
                                    _createElementVNode("div", null, [
                                        _createElementVNode("input", {
                                            id: "radio_button_promotion_No",
                                            value: "No",
                                            name: "promotion",
                                            type: "radio",
                                            class: "focus:ring-indigo-500 h-4 w-4 text-indigo-600 border-gray-300 rounded cursor-pointer disabled:bg-gray-200 disabled:border-none disabled:cursor-not-allowed",
                                            disabled: _ctx.disableForm,
                                            checked: _ctx.formData?.promotion === 'No',
                                            onChange: _cache[53] || (_cache[53] =
                                                //@ts-ignore
                                                (...args) => (_ctx.handleInput && _ctx.handleInput(...args))),
                                            onBlur: _cache[54] || (_cache[54] = ($event) => (_ctx.v$.formData.promotion.$touch()))
                                        }, null, 40, _hoisted_134)
                                    ]),
                                    _createTextVNode(),
                                    _hoisted_135
                                ])
                            ]),
                            _createTextVNode(),
                            _createElementVNode("div", _hoisted_136, [
                                _hoisted_137,
                                _createTextVNode(),
                                (_ctx.v$.formData.secondment.$error)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_138, "\n                * " + _toDisplayString(_ctx.v$.formData.secondment.$errors[0].$message), 1))
                                    : _createCommentVNode("", true),
                                _createTextVNode(),
                                _createElementVNode("div", _hoisted_139, [
                                    _createElementVNode("div", null, [
                                        _createElementVNode("input", {
                                            id: "radio_button_secondment_Yes",
                                            value: "Yes",
                                            name: "secondment",
                                            type: "radio",
                                            class: "focus:ring-indigo-500 h-4 w-4 text-indigo-600 border-gray-300 rounded cursor-pointer disabled:bg-gray-200 disabled:border-none disabled:cursor-not-allowed",
                                            disabled: _ctx.disableForm,
                                            checked: _ctx.formData?.secondment === 'Yes',
                                            onChange: _cache[55] || (_cache[55] =
                                                //@ts-ignore
                                                (...args) => (_ctx.handleInput && _ctx.handleInput(...args))),
                                            onBlur: _cache[56] || (_cache[56] = ($event) => (_ctx.v$.formData.secondment.$touch()))
                                        }, null, 40, _hoisted_140)
                                    ]),
                                    _createTextVNode(),
                                    _hoisted_141
                                ]),
                                _createTextVNode(),
                                _createElementVNode("div", _hoisted_142, [
                                    _createElementVNode("div", null, [
                                        _createElementVNode("input", {
                                            id: "radio_button_secondment_No",
                                            value: "No",
                                            name: "secondment",
                                            type: "radio",
                                            class: "focus:ring-indigo-500 h-4 w-4 text-indigo-600 border-gray-300 rounded cursor-pointer disabled:bg-gray-200 disabled:border-none disabled:cursor-not-allowed",
                                            disabled: _ctx.disableForm,
                                            checked: _ctx.formData?.secondment === 'No',
                                            onChange: _cache[57] || (_cache[57] =
                                                //@ts-ignore
                                                (...args) => (_ctx.handleInput && _ctx.handleInput(...args))),
                                            onBlur: _cache[58] || (_cache[58] = ($event) => (_ctx.v$.formData.secondment.$touch()))
                                        }, null, 40, _hoisted_143)
                                    ]),
                                    _createTextVNode(),
                                    _hoisted_144
                                ])
                            ]),
                            _createTextVNode(),
                            _createElementVNode("div", _hoisted_145, [
                                _hoisted_146,
                                _createTextVNode(),
                                (_ctx.v$.formData.existingAllowance.$error)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_147, "\n                * " + _toDisplayString(_ctx.v$.formData.existingAllowance.$errors[0].$message), 1))
                                    : _createCommentVNode("", true),
                                _createTextVNode(),
                                _createElementVNode("div", _hoisted_148, [
                                    _createElementVNode("div", null, [
                                        _createElementVNode("input", {
                                            id: "radio_button_existingAllowance_Yes",
                                            value: "Yes",
                                            name: "existingAllowance",
                                            type: "radio",
                                            class: "focus:ring-indigo-500 h-4 w-4 text-indigo-600 border-gray-300 rounded cursor-pointer disabled:bg-gray-200 disabled:border-none disabled:cursor-not-allowed",
                                            disabled: _ctx.disableForm,
                                            checked: _ctx.formData?.existingAllowance === 'Yes',
                                            onChange: _cache[59] || (_cache[59] =
                                                //@ts-ignore
                                                (...args) => (_ctx.handleInput && _ctx.handleInput(...args))),
                                            onBlur: _cache[60] || (_cache[60] = ($event) => (_ctx.v$.formData.existingAllowance.$touch()))
                                        }, null, 40, _hoisted_149)
                                    ]),
                                    _createTextVNode(),
                                    _hoisted_150
                                ]),
                                _createTextVNode(),
                                _createElementVNode("div", _hoisted_151, [
                                    _createElementVNode("div", null, [
                                        _createElementVNode("input", {
                                            id: "radio_button_existingAllowance_No",
                                            value: "No",
                                            name: "existingAllowance",
                                            type: "radio",
                                            class: "focus:ring-indigo-500 h-4 w-4 text-indigo-600 border-gray-300 rounded cursor-pointer disabled:bg-gray-200 disabled:border-none disabled:cursor-not-allowed",
                                            disabled: _ctx.disableForm,
                                            checked: _ctx.formData?.existingAllowance === 'No',
                                            onChange: _cache[61] || (_cache[61] =
                                                //@ts-ignore
                                                (...args) => (_ctx.handleInput && _ctx.handleInput(...args))),
                                            onBlur: _cache[62] || (_cache[62] = ($event) => (_ctx.v$.formData.existingAllowance.$touch()))
                                        }, null, 40, _hoisted_152)
                                    ]),
                                    _createTextVNode(),
                                    _hoisted_153
                                ])
                            ]),
                            _createTextVNode(),
                            (_ctx.model.existingAllowance === 'Yes')
                                ? (_openBlock(), _createElementBlock("div", _hoisted_154, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.model.existingAllowanceInformation, (allowance, index) => {
                                        return (_openBlock(), _createElementBlock("div", {
                                            key: allowance,
                                            class: "p-2 m-4 border border-gray-200 rounded"
                                        }, [
                                            _createElementVNode("div", _hoisted_155, [
                                                _createElementVNode("div", _hoisted_156, [
                                                    _hoisted_157,
                                                    _createTextVNode(),
                                                    (index !== 0)
                                                        ? (_openBlock(), _createBlock(_component_XIcon, {
                                                            key: 0,
                                                            class: "h-5 w-5 text-gray-400 hover:text-gray-800 cursor-pointer",
                                                            onClick: _withModifiers(($event) => (_ctx.removeAllowance(index)), ["prevent"])
                                                        }, null, 8, ["onClick"]))
                                                        : _createCommentVNode("", true)
                                                ]),
                                                _createTextVNode(),
                                                _createElementVNode("input", {
                                                    value: allowance.existingAllowanceName,
                                                    type: "text",
                                                    name: "existingAllowanceName",
                                                    class: "mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border border-gray-300 rounded-md disabled:cursor-not-allowed disabled:bg-gray-200 disabled:cursor-not-allowed",
                                                    disabled: _ctx.disableForm,
                                                    onInput: ($event) => (_ctx.handleAllowanceChange($event, index))
                                                }, null, 40, _hoisted_158)
                                            ]),
                                            _createTextVNode(),
                                            _createElementVNode("div", _hoisted_159, [
                                                _hoisted_160,
                                                _createTextVNode(),
                                                _createElementVNode("input", {
                                                    value: allowance.existingAllowanceAmount,
                                                    type: "text",
                                                    name: "existingAllowanceAmount",
                                                    class: "mt-1 focus:ring-indigo-500 focus:border-indigo-500 block w-full shadow-sm sm:text-sm border border-gray-300 rounded-md disabled:cursor-not-allowed disabled:bg-gray-200 disabled:cursor-not-allowed",
                                                    disabled: _ctx.disableForm,
                                                    onInput: ($event) => (_ctx.handleAllowanceChange($event, index))
                                                }, null, 40, _hoisted_161)
                                            ])
                                        ]));
                                    }), 128)),
                                    _createTextVNode(),
                                    _createElementVNode("div", _hoisted_162, [
                                        _createElementVNode("button", {
                                            class: "inline-flex items-center justify-center rounded-md border border-transparent bg-green-700 hover:bg-green-800 hover:underline px-4 py-2 text-sm font-medium text-white shadow-sm hover:bg-green-800 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 sm:w-auto",
                                            onClick: _cache[63] || (_cache[63] = _withModifiers(
                                            //@ts-ignore
                                            (...args) => (_ctx.addAllowance && _ctx.addAllowance(...args)), ["prevent"]))
                                        }, "\n                  Add allowance +\n                ")
                                    ])
                                ]))
                                : _createCommentVNode("", true)
                        ]))
                        : _createCommentVNode("", true),
                    _createTextVNode(),
                    _hoisted_163,
                    _createTextVNode(),
                    _hoisted_164,
                    _createTextVNode(),
                    _createVNode(_component_FileUploader, {
                        name: "right-to-work",
                        disabled: _ctx.disableForm,
                        files: _ctx.formData?.files || [],
                        "document-short-id": _ctx.formData?.shortId || _ctx.shortId,
                        uploading: _ctx.uploading,
                        onUpdateFiles: _ctx.handleUpdateFiles,
                        onFileUploading: _cache[64] || (_cache[64] = ($event) => (_ctx.uploading = $event))
                    }, null, 8, ["disabled", "files", "document-short-id", "uploading", "onUpdateFiles"])
                ])
            ]),
            _createTextVNode(),
            (_ctx.editable || (!_ctx.disableForm && _ctx.document.currentStageName === 'offer.notifyPrepOffer'))
                ? (_openBlock(), _createElementBlock("div", _hoisted_165, [
                    _createElementVNode("button", {
                        type: "submit",
                        class: "bg-green-500 border border-transparent rounded-md shadow-sm py-2 px-4 inline-flex justify-center text-sm font-medium text-white hover:bg-green-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 disabled:cursor-not-allowed disabled:bg-gray-200 disabled:text-gray-400",
                        disabled: (_ctx.formData.internal_candidate === 'No' && (!_ctx.formData?.files || !_ctx.formData?.files?.length)) || _ctx.v$.$invalid || _ctx.uploading,
                        onClick: _cache[65] || (_cache[65] = _withModifiers(
                        //@ts-ignore
                        (...args) => (_ctx.submitForm && _ctx.submitForm(...args)), ["prevent"]))
                    }, "\n          Save\n        ", 8, _hoisted_166)
                ]))
                : _createCommentVNode("", true)
        ])
    ]));
}
